import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import { getShortlistTalents, type GetShortlistTalentsParams } from './talentsApi';

export const SHORTLIST_TALENTS_QUERY_KEY = ['shortlists', 'talents'] as const;

/**
 * Lista paginada de talents dentro de un shortlist. `retry: false` para el caso
 * 404 (shortlist no accesible) — TanStack no debe re-intentar ahí porque la
 * respuesta semántica es estable, no transitoria.
 */
export function useShortlistTalents(params: GetShortlistTalentsParams) {
  return useQuery({
    queryKey: [...SHORTLIST_TALENTS_QUERY_KEY, params.shortlistPublicKey, params.pageNumber ?? 1, params.pageSize ?? 50],
    queryFn: () => getShortlistTalents(params),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    retry: (failureCount, error) => {
      // 404 anti-enumeration: stop. Otros 4xx ya stop por default global, pero
      // este hook es explícito sobre el caso.
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}
